module.exports = __webpack_public_path__ + "static/media/step-4-bw.0a6e0eb0.png";